import React, { CSSProperties, useEffect } from 'react';
import useApi from './hooks/useApi';

const Home: React.FC = () => {
  const { securedRequest, error } = useApi();

  useEffect(() => {
    const controller = new AbortController();
    const callApi = async () => {
      const { data } = await securedRequest('GET', '/api/login', null, controller.signal);
      if (data && data.url) {
        window.location.href = data.url;
      }
    };
    callApi();
    return () => {
      controller.abort();
    };
  }, [securedRequest]);

  const containerStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '1.5rem',
    backgroundColor: '#f7f7f7',
    color: '#333',
    fontFamily: 'Helvetica, Arial, sans-serif',
  };

  const errorWrapperStyle: CSSProperties = {
    textAlign: 'center',
    padding: '40px',
  };

  const h1Style: CSSProperties = {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '20px',
    borderBottom: '1px solid #ccc',
    paddingBottom: '20px',
  };

  const pStyle: CSSProperties = {
    fontSize: '1rem',
    marginTop: '20px',
  };

  const svgStyle: CSSProperties = {
    width: '50px',
    height: '50px',
    marginBottom: '20px',
  };

  if (error) {
    return (
      <div style={containerStyle}>
        <div style={errorWrapperStyle}>
          <svg style={svgStyle} viewBox="0 0 52 52">
            <circle cx="26" cy="26" r="25" fill="#f8d7da" />
            <path d="M16 16 36 36 M36 16 16 36" stroke="#721c24" strokeWidth="4" />
          </svg>
          <h1 style={h1Style}>We're sorry, something went wrong.</h1>
          <p style={pStyle}>
            If issues persist, reach out to your LocaliQ sales representative for additional assistance.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div>Loading...</div>
    </div>
  );
};

export default Home;